module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/developer/sass-d8a1121d3a6db260a47565ec437cdd33.svg";